import { GetAllQaQcTestsResponse, QaQcDropDown, QaQcResponse, QaQcTestsDropDownResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { OperationRequest } from '../operations/dto/operations.request';
import { QaQcData } from './dto/qa-qc-data.dto';
import { QaQcTestIdRequest } from './dto/qa-qc-test-id.request';
import { QaQcOperationsService } from './qa-qc-operations.service';

@ApiTags('QA/QC operations')
@Controller('qa-qc-operations')
export class QaQcOperationsController {
    constructor(private qaQcService: QaQcOperationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    /**
     * 
     * @param qaQcDTO 
     * @returns created Data response
     */
    @Post('/createQaQcTest')
    async createQaQcTest(@Body() qaQcDTO: QaQcData): Promise<QaQcResponse> {
        try {
            return await this.qaQcService.createQaQcTest(qaQcDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(QaQcResponse, error)
        }
    }

    /**
     * 
     * @param qaQcDTO 
     * @returns QaQcResponse 
     */
    @Post('/updateQaQcTest')
    async updateQaQcTest(@Body() qaQcDTO: QaQcData): Promise<QaQcResponse> {
        try {
            return await this.qaQcService.createQaQcTest(qaQcDTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(QaQcResponse, error)
        }
    }


    /**
     * 
     * @returns GetAllQaQcTestsResponse
     */
    @Post('/getAllQcQcTests')
    async getAllQcQcTests(): Promise<GetAllQaQcTestsResponse> {
        try {
            return await this.qaQcService.getAllQcQcTests();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllQaQcTestsResponse, error)
        }
    }

    /**
     * 
     * @param req operation id
     * @returns get all tests against operations
     */
    @Post('/getAllQcQcTestsForOperation')
    async getAllQcQcTestsForOperation(@Body() req: OperationRequest): Promise<GetAllQaQcTestsResponse> {
        try {
            return await this.qaQcService.getAllQcQcTestsForOperation(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllQaQcTestsResponse, error)
        }
    }

    @Post('/activateOrDeactivateQaQcTest')
    async activateOrDeactivateQaQcTest(@Body() idReq: QaQcTestIdRequest): Promise<QaQcResponse> {
        try {
            return await this.qaQcService.activateOrDeactivateQaQcTest(idReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(QaQcResponse, err);
        }
    }

    /**
    * 
    * @returns GetAllQaQcTestsResponse
    */
    @Post('/getAllQcQcActiveTests')
    async getAllQcQcActiveTests(): Promise<GetAllQaQcTestsResponse> {
        try {
            return await this.qaQcService.getAllQcQcActiveTests();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllQaQcTestsResponse, error)
        }
    }

    /**
   * 
   * @returns GetAllQaQcTestsResponse
   */
    @Post('/getAllQcQcActiveTestsForOperation')
    async getAllQcQcActiveTestsForOperation(@Body() req: OperationRequest): Promise<GetAllQaQcTestsResponse> {
        try {
            return await this.qaQcService.getAllQcQcActiveTestsForOperation(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllQaQcTestsResponse, error)
        }
    }

    /**
     * 
     * @returns QaQcTestsDropDownResponse
     */
    @Post('/getAllQcQcDropDownForOperation')
    async getAllQcQcDropDownForOperation(@Body() req: OperationRequest): Promise<QaQcTestsDropDownResponse> {
        try {
            return await this.qaQcService.getAllQcQcDropDownForOperation(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(QaQcTestsDropDownResponse, error)
        }
    }
    @Post('/getTestDataForTestId')
  async getTestDataForTestId(@Body() testIdRequest: QaQcTestIdRequest): Promise<QaQcDropDown> {
    try {
      return await this.qaQcService.getTestDataForTestId(testIdRequest.qaQcTestId);
    } catch (error) {
      throw error
    }
  }
}
